import { Routes } from '@angular/router';
import { PrivateLayoutComponent } from './layout/private-layout/private-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
export const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,

    loadChildren: () =>
      import('./feature/auth/auth.routes').then((m) => m.default),
  },
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'hubs',
        pathMatch: 'full',
      },
      {
        path: 'hubs',
        loadChildren: () =>
          import('./feature/hubs/hubs.routes').then((m) => m.default),
      },
      {
        path: 'parking-spots',
        loadChildren: () =>
          import('./feature/parking-spots/parking-spots.routes').then(
            (m) => m.default,
          ),
      },
      {
        path: 'admins',
        loadChildren: () =>
          import('./feature/admins/admins.routes').then((m) => m.default),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./feature/users/users.routes').then((m) => m.default),
      },
      // {
      //   path: 'logs',
      //   loadChildren: () =>
      //     import('./feature/logs/logs.routes').then((m) => m.default),
      // },
      // {
      //   path: 'firmware',
      //   loadChildren: () =>
      //     import('./feature/firmware/firmware.routes').then((m) => m.default),
      // },
      {
        path: '**',
        redirectTo: '',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
